import { registerApplication, start } from "single-spa";
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from "single-spa-layout";
import microfrontendLayout from "./microfrontend-layout.html";

// const appConfig = window.__env.configs["appConfig"];
let interval = setInterval(() => {
  const appConfig = window?.__env?.configs["appConfig"];
  if (appConfig) {
    clearInterval(interval); // Stop the interval once appConfig is loaded
    // You can add further logic here if needed
    mainExecution(appConfig)
  }
}, 300);

const mainExecution = (appConfig) => {
  let piSessionScript = document.createElement("script");
  piSessionScript.src = appConfig["PI_API"];
  document.body.appendChild(piSessionScript);
  
  let inputPiUserId = document.createElement("input");
  inputPiUserId.type = "hidden";
  inputPiUserId.id = "pi_user_id";
  document.body.appendChild(inputPiUserId);
  let isApplicationStart = false;
  
  const loadApplication = () => {
    let data = {
      props: {
        env: appConfig["ENV"],
        userId: window?.piSession?.userId(),
        userToken: window?.piSession?.currentToken()
      },
    };
    const routes = constructRoutes(microfrontendLayout, data);
    
    const applications = constructApplications({
      routes,
      loadApp({ name }) {
        return System.import(name);      
      },
    });
  
    const layoutEngine = constructLayoutEngine({ routes, applications }); 
  
    applications.forEach(registerApplication);
    layoutEngine.activate();
    start();
    isApplicationStart = true;  
  };

function redirectHandle(path){
  let pathName;
  if(path && path !== '/'){
    pathName = path;
  }else{
    pathName = '/institution';
  }

  return pathName;
}

function startPiSession() {
    let session = window.piSession;
    if (!session) return console.error("piSession did not load!");
    window.piSession.initialize(appConfig["PI_CLIENT_ID"], {
      sessionIdleTimeoutSeconds: 1800,
    });

    window.piSession.on(window.piSession.RefreshEvent, function (eventData) {
      if (session.hasValidSession(10) !== "success") {
        let params = new URLSearchParams(window.location.search);
        window.piSession.login(
          `${window.location.origin}${
            redirectHandle(window.location.pathname)
          }?${params.toString()}`
        );
      } else {
        if (!isApplicationStart) {
          loadApplication();  
        }
        
      }
    });

    session.on(session.SessionStateKnownEvent, function () {
      if (session.hasValidSession(10) !== "success") {
        let params = new URLSearchParams(window.location.search);
        window.piSession.login(
          `${window.location.origin}${
            redirectHandle(window.location.pathname)
          }?${params.toString()}`
        );
      }

      session.on(session.LoginEvent, function () {
        if (session.hasValidSession(10) === "success") {
          setTimeout(function () {
            window.location.reload();
          }, 2000);
        }
      });

      session.on(session.LogoutEvent, function () {
        let params = new URLSearchParams(window.location.search);
        window.piSession.login(
          `${window.location.origin}${
            redirectHandle(window.location.pathname)
          }?${params.toString()}`
        );
      });
      
    });
  }
  piSessionScript.onload = startPiSession;
} 